export enum ChatActionEnum {
  Join = 'join',
  Leave = 'leave',
  Image = 'image',
  File = 'file',
  Message = 'message',
  Appointment = 'appointment',
}
